import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { formatNumber } from 'accounting-js';

import { Form } from 'common/components';
import AssetsDepreciationChart from 'components/assets/depreciation/AssetsDepreciationChart';

class AssetesDepreciationDetail extends PureComponent {
  static propTypes = {
    depreciation: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
  };

  render = () => (
    <div className="row">
      <div className="col-sm-12">
        <h5>
          <b>{this.props.t(this.props.title)}</b>
        </h5>
        <br />
      </div>
      <div className="col-sm-4 col-md-6">
        <div className="row">
          <div className="col-sm-6 col-xl-4">
            <Form.FieldInput
              className="text-right"
              iconLeft={'usd'}
              name={'moi'}
              label={this.props.t('assets.fields.moi')}
              value={formatNumber(this.props.depreciation.originalAmount || 0)}
              readOnly={true}
            />
          </div>
          <div className="col-sm-6 col-xl-4">
            <Form.FieldInput
              className="text-right"
              iconLeft={'usd'}
              name={'depreciation'}
              label={this.props.t('assets.depreciation')}
              value={formatNumber(this.props.depreciation.totalDepreciation || 0)}
              readOnly={true}
            />
          </div>
          <div className="col-sm-6 col-xl-4">
            <Form.FieldInput
              className="text-center"
              iconRight={'percent'}
              name={'depreciationPercentage'}
              label={this.props.t('assets.depreciationPercentage')}
              value={formatNumber(this.props.depreciation.totalPercentage || 0)}
              readOnly={true}
            />
          </div>
          <div className="col-sm-6 col-xl-4">
            <Form.FieldInput
              className="text-right"
              iconLeft={'usd'}
              name={'depreciable'}
              label={this.props.t('assets.depreciable')}
              value={formatNumber(this.props.depreciation.depreciable || 0)}
              readOnly={true}
            />
          </div>
          <div className="col-sm-6 col-xl-4">
            <Form.FieldInput
              className="text-right"
              name={'remainingLife'}
              label={this.props.t('assets.fields.remainingLife')}
              value={formatNumber(this.props.depreciation.lifeYears || 0, { precision: 4 })}
              readOnly={true}
            />
          </div>
          <div className="col-sm-12">
            <Form.FieldInput
              name={'depreciationName'}
              label={this.props.t('assets.fields.depreciationName')}
              value={this.props.depreciation.name}
              readOnly={true}
            />
          </div>
        </div>
      </div>
      <div className="col-sm-8 col-md-6 mb-2">
        <AssetsDepreciationChart
          depreciation={this.props.depreciation.totalDepreciation}
          depreciable={this.props.depreciation.depreciable}
          label={'Depreciacion'}
        />
      </div>
    </div>
  );
}

export default translate()(AssetesDepreciationDetail);



// WEBPACK FOOTER //
// src/components/assets/depreciation/AssetsDepreciationValues.js